import { Space } from '@sravni/react-design-system';

import {
  EBS_DEFAULT_CONTENT,
  EBS_DEFAULT_GUIDE_ALERT_DESKTOP,
  EBS_DEFAULT_GUIDE_ALERT_MOBILE,
} from '../../EbsDialogBanner.config';
import styles from '../../EbsDialogBanner.module.scss';
import { EbsCustomAlert } from '../EbsCustomAlert/EbsCustomAlert';
import { EbsInformer } from '../EbsInformer/EbsInformer';

export function EbsBannerDefaultGuide({ isMobile }: { isMobile: boolean }) {
  return (
    <Space size={0} direction="column">
      <EbsCustomAlert
        isLargeRadius
        className={styles.customAlert}
        isLarge
        content={isMobile ? EBS_DEFAULT_GUIDE_ALERT_MOBILE : EBS_DEFAULT_GUIDE_ALERT_DESKTOP}
      />
      <Space direction="column" size={8} className={styles.gridContainer}>
        {EBS_DEFAULT_CONTENT(isMobile).map((info, step) => (
          // eslint-disable-next-line react/no-array-index-key
          <EbsInformer key={`step-id-${step}`} step={step + 1} {...info} />
        ))}
      </Space>
    </Space>
  );
}
